export default "__VITE_ASSET__807f5639__"